import { ICON } from './icons';

// TODO: Export new icon from Figma for unmanaged
export const ACTIVITY = {
  COOLING: {
    key: 'Cooling',
    label: 'Cooling',
    icon: ICON.ACTIVITY.COOLING,
  },
  HEATING: {
    key: 'Heating',
    label: 'Heating',
    icon: ICON.ACTIVITY.HEATING,
  },
  FAN: {
    key: 'Fan',
    label: 'Fan',
    icon: ICON.ACTIVITY.FAN,
  },
  IDLE: {
    key: 'Idle',
    label: 'Idle',
    icon: ICON.ACTIVITY.IDLE,
  },
  ECONOMIZING: {
    key: 'Economizing',
    label: 'Economizing',
    icon: ICON.ACTIVITY.ECONOMIZING,
  },
  PROBLEM: {
    key: 'Problem',
    label: 'Problem',
    icon: ICON.ACTIVITY.PROBLEM,
  },
  OFFLINE: {
    key: 'Offline',
    label: 'Offline',
    icon: ICON.ACTIVITY.OFFLINE,
  },
  UNMANAGED: {
    key: 'Unmanaged',
    label: 'Unmanaged',
    icon: ICON.ACTIVITY.UNMANAGED,
  },
  IN_OVERRIDE: {
    key: 'In Override',
    label: 'In Override',
    icon: ICON.CONTROL_MODE.OVERRIDE,
  },
  OFF: {
    key: 'Off',
    label: 'Off',
    icon: ICON.ACTIVITY.OFF,
  },
  DEFAULT: {
    key: 'Default',
    label: 'Default',
    icon: ICON.ACTIVITY.UNMANAGED,
  },
};
